import { ref } from 'vue'
import { defineStore } from 'pinia'
import FluentCRM from '../views/integrations-configs/FluentCRM.vue'
import Mailchimp from '../views/integrations-configs/Mailchimp.vue'
import GoogleSheets from '../views/integrations-configs/GoogleSheets.vue'

export const useIntegrationModal = defineStore('integrationModal', () => {
    const isOpen = ref(false)
    const currentIntegration = ref(null)
    const modalContents = {
        'fluent-crm': FluentCRM,
        'mailchimp': Mailchimp,
        'google_sheets': GoogleSheets,
    }

    const openModal = (integration) => {
        currentIntegration.value = integration
        isOpen.value = true
    }
    
    const closeModal = () => {
        isOpen.value = false
        currentIntegration.value = null
    }
    
    return {
        isOpen,
        currentIntegration,
        openModal,
        closeModal,
        modalContents
    }
})